const elementClasses = {
    toggle: `toggle`,
    hasNavigationToggled: `has-navigation-toggled`,
    a11yMenuHasSubChildres: `a11y-menu--has-sub-children`,
    a11yMenuHasChildres: `a11y-menu--has-children`,
    hasExpandedSubMenu: `has-expanded-sub-menu`,
    subSubMenu: `sub-sub-menu`,
    subMenu: `sub-menu`,
    mainItem: `main-item`,
}

const DOMElemets = {
    expandedMenus: (toggleSelector, element = `button`) => {
        if (typeof(toggleSelector) !== 'string') {
            console.warn("The variable toggleSubSubMenuSelector is not a string.");
            return;
        }

        let selector = toggleSelector;

        if (selector.charAt(0) !== '.') {
            selector = `.${selector}`;
        }

        return document.querySelectorAll(`${element}${selector}[aria-expanded="true"]`);
    }
}

let _globalSelectors = {} 

/**
 * 
 * @param {{
 * navbar: string, //#site-navigation
 * hamburgerMenu: string,   //#menu-toggle
 * menuNav: string, //#menu-primary
 * subMenuButtons: string,  //button-toggle-sub-menu
 * subSubMenuButtons: string,   //button-toggle-sub-sub-menu
 * backButtons: string, //back-btn
 * btnNavNoChildres: string, //btn-nav-nochildren
 * mainNav: string, //.main-nav
 * }} selectors 
 * 
 * @param {boolean} enableCloseMenuWithOutsideClick Imposta a true (default) se vuoi che il menù si chiuda quando viene cliccato fuori, altrimenti imposta questo parametro a false.
 * 
 * @returns 
 */
export function initialize(selectors = {
    navbar: `#site-navigation`,
    hamburgerMenu: `#menu-toggle`,
    menuNav: `#menu-primary`,
    subMenuButtons: `.button-toggle-sub-menu`,
    subSubMenuButtons: `.button-toggle-sub-sub-menu`,
    backButtons: `.back-btn`,
    btnNavNoChildres: `.btn-nav-nochildren`,
    mainNav: `.main-nav`,
}, enableCloseMenuWithOutsideClick = true) {
    console.log("Initialize the navbar menu");

    _globalSelectors = selectors; 
    
    //#region Safeguards
    var errorCode = 0;

    if (typeof(selectors.navbar) === 'undefined') {
        console.error("Navbar definition is missing.");
        errorCode |= 1 << 0;
    }

    if (typeof(selectors.hamburgerMenu) === 'undefined') {
        console.error("Hamburger menu definition is missing.");
        errorCode |= 1 << 1;
    }

    if (typeof(selectors.menuNav) === 'undefined') {
        console.error("Navbar content definition is missing.");
        errorCode |= 1 << 2;
    }

    if (typeof(selectors.subMenuButtons) === 'undefined') {
        console.error("Sub-menu buttons definition is missing.")
        errorCode |= 1 << 3;
    }

    if (typeof(selectors.subSubMenuButtons) === `undefined`) {
        console.error("Sub-sub-menu buttons definition is missing.");
        errorCode |= 1 << 4;
    }

    if (typeof(selectors.backButtons) === `undefined`) {
        console.error(`Back buttons definition is missing.`);
        errorCode |= 1 << 5;
    }

    if (typeof(selectors.btnNavNoChildres) === `undefined`) {
        console.error(`Navigation buttons with no children definition is missing.`);
        errorCode |= 1 << 6;
    }

    if (typeof(selectors.mainNav) === `undefined`) {
        console.error(`Main nav definition is missing.`);
        errorCode |= 1 << 7;
    }

    if (errorCode != 0) {
        console.error(`Unable to initialize the navbar.\nError code: ${errorCode}`);
        return false;
    }
    //#endregion

    const navbar = document.querySelector(selectors.navbar);    //e
    const hamburgerMenu = document.querySelector(selectors.hamburgerMenu);  //t
    const navbarMenu = document.querySelector(selectors.menuNav); //menu-primary
    const backButtons = document.querySelectorAll(selectors.backButtons);

    //#region Navigation bar
    if (navbar) {
        if (hamburgerMenu) {
            if (navbarMenu) {
                hamburgerMenu.addEventListener(`click`, e => {
                    toggleMenu(navbar, hamburgerMenu, selectors.subMenuButtons, selectors.subSubMenuButtons);
                });

                document.addEventListener(`keydown`, e => {
                    const isShiftPressed = () =>  e.key === "ShiftLeft" || e.key === "ShiftRight";

                    if (isElementToggled(navbar)) {
                        const els = navbar.querySelectorAll(`a, button, input:not([type="hidden"]), select`);
                        const firstElement = els[0];
                        const lastElement = els[els.length - 1];
                        const activeElement = document.activeElement;

                        if (e.key == "Escape") {
                            e.preventDefault();
                            toggleMenu();
                            hamburgerMenu.focus();
                        }

                        if (!isShiftPressed() && e.key === "Tab" && lastElement === activeElement) {
                            e.preventDefault();
                            firstElement.focus();
                        }

                        if (isShiftPressed() && e.key === "Tab" && firstElement === activeElement) {
                            e.preventDefault();
                            lastElement.focus();
                        }

                        if (e.key === "Tab" && firstElement === lastElement) {
                            e.preventDefault();
                        }
                    }
                });
            }
            else {
                hamburgerMenu.style.display = "none";
            }
        }
        else {
            console.warn(`Hamburger menu HTMLElement is missing.`);
        }
    }
    else {
        console.warn(`Navbar HTMLElement is missing`);
    }
    //#endregion

    //#region Back buttons click handler
    backButtons.forEach(b => {
        b.addEventListener(`click`, e => {
            e.stopPropagation();
            e.preventDefault();

            const subSubMenu = b.closest("." + elementClasses.subSubMenu);
            if (subSubMenu) {
                const toggleButton = subSubMenu.parentElement.querySelector(selectors.subSubMenuButtons);
                if (toggleButton) {
                    toggleButton.setAttribute(`aria-expanded`, `false`);

                    const parentLi = subSubMenu.parentElement;
                    if (parentLi) {
                        parentLi.classList.remove(elementClasses.hasExpandedSubMenu);
                    }
                    else {
                        console.warn(`Parent element was not found.`);
                    }

                    setSubMenuHeight(toggleButton);
                }
                else {
                    console.warn(`Toggle button was not found.`);
                }
            }
            else {
                console.warn(`Sub-sub-menu was not found.`);
            }
        });
    });
    //#endregion

    //#region Navigation buttons with no children click handler
    document.querySelectorAll(selectors.btnNavNoChildres).forEach(btn => {
        btn.addEventListener(`click`, e => {
            const href = btn.getAttribute(`data-href`);
            if (href?.length > 0) {
                window.location.href = href;
            }
        });
    });
    //#endregion

    //#region Handle accessibility
    if (document.readyState === `loading`) {
        document.addEventListener(`DOMContentLoaded`, () => {
            handleAccessibility(selectors.subMenuButtons, selectors.subSubMenuButtons, selectors.menuNav);
        })
    }
    else {
        handleAccessibility(selectors.subMenuButtons, selectors.subSubMenuButtons, selectors.menuNav);
    }
    //#endregion

    //#region Add listeners on button toggle sub menu for resetting the sub sub menu
    document.addEventListener('DOMContentLoaded', function() {
        const subMenuToggles = document.querySelectorAll(selectors.subMenuButtons);
        
        subMenuToggles.forEach(toggle => {
            toggle.addEventListener('click', function() {
                console.log("=== CLICK SU BUTTON-TOGGLE-SUB-MENU ===");
                
                const expandedClass = elementClasses.hasExpandedSubMenu;
                const parentLi = toggle.closest(`.${elementClasses.a11yMenuHasChildres}`);
                
                // Se stiamo per CHIUDERE il sub-menu (ha già la classe expanded)
                if (parentLi && !parentLi.classList.contains(expandedClass)) {
                    console.log("Sto chiudendo il sub-menu, resetto i sub-sub-menu");
                    
                    // Trova tutti i sub-sub-menu aperti dentro questo sub-menu
                    const openSubSubMenus = parentLi.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.` + expandedClass);
                    console.log("Sub-sub-menu aperti trovati:", openSubSubMenus.length);
                    
                    openSubSubMenus.forEach(subSubMenu => {
                        console.log("Chiudo sub-sub-menu:", subSubMenu);
                        subSubMenu.classList.remove(expandedClass);
                        
                        //const subSubButton = subSubMenu.querySelector('.button-toggle-sub-sub-menu');
                        const subSubButton = subSubMenu.querySelector(selectors.subSubMenuButtons);
                        if (subSubButton) {
                            subSubButton.setAttribute('aria-expanded', 'false');
                            subSubButton.setAttribute('aria-label', 'Apri il sottomenù');
                        }
                    });
                }
            });
        });

        //-----------------------------------------------------------------------------------------

        document.querySelectorAll(selectors.subSubMenuButtons).forEach(button => {
            button.addEventListener(`click`, e => {
                if (!isExpandedSubSubMenu(button, selectors.subSubMenuButtons)) {
                    setSubMenuHeight(button);
                }
            });
        });

        //-----------------------------------------------------------------------------------------

        window.addEventListener(`resize`, () => {
            resetSubMenuHeights(selectors.mainNav, selectors.menuNav);
        });

        // ========================= Auto apertura del primo sub-sub menu ===================
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    
                    // Verifica se è un main-item che ha appena ricevuto la classe expanded
                    if (target.classList.contains(elementClasses.mainItem) && 
                        target.classList.contains(elementClasses.hasExpandedSubMenu)) {
                        
                        // CONTROLLO LARGHEZZA: funziona solo da 1060px in su
                        if (window.innerWidth >= 1060) {
                            // Aspetta che il sub-menu sia visibile
                            setTimeout(() => {
                                const subMenu = target.querySelector(`.${elementClasses.subMenu}`);
                                if (subMenu) {
                                    // Trova tutti i li con sub-sub-menu
                                    const subSubMenuItems = subMenu.querySelectorAll(`li.${elementClasses.a11yMenuHasSubChildres}`);
                                    
                                    if (subSubMenuItems.length > 0) {
                                        const firstItem = subSubMenuItems[0];
                                        
                                        // Verifica che non sia già aperto
                                        if (!firstItem.classList.contains(elementClasses.hasExpandedSubMenu)) {
                                            // Aggiungi la classe expanded
                                            firstItem.classList.add(elementClasses.hasExpandedSubMenu);
                                            
                                            // Trova e aggiorna il button
                                            //const button = firstItem.querySelector('.button-toggle-sub-sub-menu');
                                            const button = firstItem.querySelector(selectors.subSubMenuButtons);
                                            if (button) {
                                                button.setAttribute('aria-expanded', 'true');
                                                button.setAttribute('aria-label', 'Chiudi il sottomenù Prestiti');
                                                
                                                // Ricalcola altezza
                                                if (typeof(setSubMenuHeight) === 'function') {
                                                    setSubMenuHeight(button);
                                                }
                                            }
                                        }
                                    }
                                }
                            }, 100);
                        }
                    }
                }
            });
        });
    
        // Osserva tutti i main-item
        const mainItems = document.querySelectorAll('.main-item.a11y-menu--has-children');
        mainItems.forEach(item => {
            observer.observe(item, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    });
    //#endregion

    //#region Chiusura menu al click fuori
    if (enableCloseMenuWithOutsideClick) {
        document.addEventListener('click', function(event) {
        // Verifica se il click è avvenuto fuori dal menu
        const isClickInsideMenu = event.target.closest(selectors.mainNav) || 
                                event.target.closest(selectors.navbar) ||
                                event.target.closest(`.${elementClasses.subMenu}`);
        
        // Se il click è fuori dal menu
            if (!isClickInsideMenu && getComputedStyle(document.getElementById(`menu-toggle`)).display === "none") {
                closeAllMenus();
            /*const expandedClass = elementClasses.hasExpandedSubMenu;
            
            // Trova tutti i sub-menu aperti (primo livello)
            const openSubMenus = document.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.` + expandedClass);
            
            openSubMenus.forEach(openMenu => {
                // Rimuovi la classe expanded
                openMenu.classList.remove(expandedClass);
                
                // Trova e aggiorna il button-toggle-sub-menu
                const button = openMenu.querySelector(`${selectors.subMenuButtons}[aria-expanded="true"]`);
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                    
                    // Aggiorna anche l'aria-label se presente
                    const collapseLabel = button.getAttribute('aria-label');
                    if (collapseLabel) {
                        button.setAttribute('aria-label', 'Apri il sottomenù');
                    }
                }
                
                // Chiudi anche eventuali sub-sub-menu aperti
                const openSubSubMenus = openMenu.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.` + expandedClass);
                openSubSubMenus.forEach(subSubMenu => {
                    subSubMenu.classList.remove(expandedClass);
                    
                    const subSubButton = subSubMenu.querySelector(`${selectors.subSubMenuButtons}[aria-expanded="true"]`);
                    if (subSubButton) {
                        subSubButton.setAttribute('aria-expanded', 'false');
                        subSubButton.setAttribute('aria-label', 'Apri il sottomenù');
                    }
                });
            });*/
        }
    });
    }
    //#endregion

    window.addEventListener(`pageshow`, e => {
        closeAllMenus();
    });

    console.log("Navbar menu is initialized.");
}

function closeAllMenus(options = {}) {
    const defaults = {
        closeHamburger: false,
        closeSubMenus: true,
        closeSubSubMenus: true,
        specificMenu: null,
        resetHeights: true
    };

    const config = { ...defaults, ...options };
    const expandedClass = elementClasses.hasExpandedSubMenu;

    // Chiusura menu hamburger
    if (config.closeHamburger) {
        const navbar = document.querySelector(_globalSelectors.navbar);
        const hamburgerMenu = document.querySelector(_globalSelectors.hamburgerMenu);

        if (navbar && isElementToggled(navbar)) {
            navbar.classList.remove(elementClasses.toggle);
            document.body.classList.remove(elementClasses.hasNavigationToggled);

            if (hamburgerMenu) {
                hamburgerMenu.setAttribute('aria-expanded', 'false');
            }
        }
    }

    // Funzione helper per chiudere un singolo menu
    const closeMenu = (menu, buttonSelector, ariaLabel = 'Apri il sottomenù') => {
        menu.classList.remove(expandedClass);

        const button = menu.querySelector(`${buttonSelector}[aria-expanded="true"]`);
        if (button) {
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-label', ariaLabel);
        }
    };

    // Chiusura sub-sub-menu
    if (config.closeSubSubMenus) {
        const selector = config.specificMenu
            ? config.specificMenu.querySelectorAll.bind(config.specificMenu)
            : document.querySelectorAll.bind(document);

        const openSubSubMenus = selector(`.${elementClasses.a11yMenuHasSubChildres}.${expandedClass}`);

        openSubSubMenus.forEach(subSubMenu => {
            // Verifica che sia effettivamente un sub-sub-menu (ha un genitore sub-menu)
            const isSubSubMenu = subSubMenu.closest(`.${elementClasses.subMenu}`);
            if (isSubSubMenu) {
                closeMenu(subSubMenu, _globalSelectors.subSubMenuButtons);

                // Reset altezza del sub-menu genitore
                if (config.resetHeights) {
                    const parentSubMenu = subSubMenu.closest(`.${elementClasses.subMenu}`);
                    if (parentSubMenu && window.innerWidth >= 1060) {
                        parentSubMenu.style.height = 'auto';
                    }
                }
            }
        });
    }

    // Chiusura sub-menu
    if (config.closeSubMenus) {
        const selector = config.specificMenu
            ? config.specificMenu.querySelectorAll.bind(config.specificMenu)
            : document.querySelectorAll.bind(document);

        const openSubMenus = selector(`.${elementClasses.mainItem}.${expandedClass}`);

        openSubMenus.forEach(subMenu => {
            closeMenu(subMenu, _globalSelectors.subMenuButtons);

            // Chiudi anche eventuali sub-sub-menu annidati se non già fatto
            if (!config.closeSubSubMenus) {
                const nestedSubSubMenus = subMenu.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.${expandedClass}`);
                nestedSubSubMenus.forEach(nested => {
                    closeMenu(nested, _globalSelectors.subSubMenuButtons);
                });
            }
        });
    }

    //Controllo che l'hamburger sia aperto
    const toggleBtn = document.querySelector(`#menu-toggle`);
    if (toggleBtn) {
        const ariaExpandedState = toggleBtn.getAttribute(`aria-expanded`);  //Controllo se expanded è true
        if (ariaExpandedState && ariaExpandedState.toLowerCase() === "true") {
            //Se il toggle è visibile...
            if (getComputedStyle(toggleBtn).display !== "none") {
                toggleBtn.click();
            }
        }
    }

    //Chiudi tutti i sub-sub-menu con aria expanded a true.
    const expandedBtns = document.querySelectorAll(`button.button-toggle-sub-sub-menu`);
    expandedBtns.forEach(btn => {
        btn.setAttribute(`aria-expanded`, `false`);
    });


    console.log('Menu chiusi:', config);
}

/**
 * 
 * @param {HTMLElement} element 
 */
function isElementToggled(element) {
    return element.classList.contains(elementClasses.toggle);
}

/**
 * 
 * @param {HTMLElement} navbar 
 * @param {HTMLElement} hamburgerMenu
 * @param {string} subMenuSelector
 * @param {string} subSubMenuSelector
 */
function toggleMenu(navbar, hamburgerMenu, subMenuSelector, subSubMenuSelector) {
    navbar.classList.toggle(elementClasses.toggle);
    document.body.classList.toggle(elementClasses.hasNavigationToggled);
    hamburgerMenu.setAttribute(`aria-expanded`, isElementToggled(navbar) ? `true` : `false`);

    if (!isElementToggled(navbar)) {

        const removeExpanded = (elements) => {
            elements.forEach(e => {
                e.setAttribute(`aria-expanded`, `false`);
                const parent = e.closest(`.${elementClasses.a11yMenuHasSubChildres}`);
                if (parent) {
                    parent.classList.remove(elementClasses.hasExpandedSubMenu);
                }
            })
        };

        removeExpanded(document.querySelectorAll(`${subSubMenuSelector}[aria-expanded="true"]`));
        removeExpanded(document.querySelectorAll(`${subMenuSelector}[aria-expanded="true"]`));
    }
}

/**
 * 
 * @param {HTMLElement} button 
 * @param {string} subSubMenuSelector
 * @returns 
 */
function setSubMenuHeight(button) {
    if (window.innerWidth < 1060) {
        return;
    }

    const parentLI = button.parentElement;
    const subSubMenu = parentLI.querySelector(`.${elementClasses.subSubMenu}`);

    if (subSubMenu) {
        const subMenu = subSubMenu.closest(`.${elementClasses.subMenu}`);

        if (subMenu) {
            setTimeout(() => {
                //Controllo l'altezza del sub-menu da auto, in modo da avere un'altezza minima su dove lavorare.
                subMenu.style.height = 'auto';
                const idleHeight = subMenu.clientHeight;

                const openedSubSubMenu = subMenu.querySelector(`.${elementClasses.hasExpandedSubMenu} > .${elementClasses.subSubMenu}`);
                if (openedSubSubMenu) {
                    console.log("A sub-sub-menu is opened.");
                    const subSubMenuHeight = openedSubSubMenu.offsetHeight;

                    const computedStyle = window.getComputedStyle(subMenu);
                    const paddingTop = parseFloat(computedStyle.paddingTop);
                    const paddingBottom = parseFloat(computedStyle.paddingBottom);
                    const totalPadding = paddingTop + paddingBottom;

                    const totalHeight = subSubMenuHeight + totalPadding;
                    const heightSet = Math.max(totalHeight, idleHeight);

                    subMenu.style.height = `${heightSet}px`;
                }
                else {
                    console.log("A sub-sub-menu is closed.");
                    subMenu.style.height = 'auto';
                }

            }, 50);
        }
        else {
            console.warn(`Sub-menu was not found.`);
        }
    }
    else {
        console.warn(`Sub-sub-menu element was not found.`);
    }
}

/**
 * 
 * @param {string} _buttonToggleSubMenuSelector 
 * @param {string} _buttonToggleSubSubMenuSelector
 * @param {string} _menuPrimarySelector
 * @param {any} _options 
 */
function handleAccessibility(_buttonToggleSubMenuSelector, _buttonToggleSubSubMenuSelector, _menuPrimarySelector, _options = {}) {
    //#region  Lambdas
    const setOptions = function() {
        const defaults = {
            button_attributes : {
                class: `${_buttonToggleSubMenuSelector}`,
                "aria-label": {
                    collapse: "Chiudi il sottomenù",
                    expand: "Apri il sottomenù",
                },
            },
            child_menu_selector: `.${elementClasses.subMenu}`,
            expanded_class: `${elementClasses.hasExpandedSubMenu}`,
            menu_selector: `${_menuPrimarySelector}`,
            mode: [`tab`, `esc`, `button`, `touch`]
        };

        options = {...defaults, ..._options};
    };

    const polyFill = function() {
        if (!NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
    };

    const getOption = function(...keys) {
        return keys.reduce((acc, key) => acc?.[key], options);
    };

    const getMenus = function() {
        if (!menus.length && getOption("menu_selector")) {
            document.querySelectorAll(getOption(`menu_selector`)).forEach(menu => {
                menus.push(menu);
            });
        }

        return menus;
    };

    const changeButtonAttribute = function(event, isSubSub = false) {
        const el = event.target?.parentNode || event;
        if (!el) {
            console.warn("Element in event was not found.");
            return;  
        }

        const buttonSelector = isSubSub ? `button${_buttonToggleSubSubMenuSelector}[aria-expanded]` : `button${_buttonToggleSubMenuSelector}[aria-expanded]`;
        const button = el.querySelector(buttonSelector);
        if (!button) {
            console.warn("Button was not found.");
            return; 
        }

        const isExpanded = el.classList.contains(getOption(`expanded_class`));
        const labels = getOption("button_attributes", "aria-label");

        if (!isExpanded && isSubSub) return false;

        button.setAttribute(`aria-expanded`, isExpanded ? "true" : "false");

        if (labels) {
            const labelText = isExpanded ? labels.collapse : labels.expand;
            button.setAttribute("aria-label", labelText);
        }

        return true;
    };

    /**
     * 
     * @param {KeyboardEvent} event 
     * @param {*} isSubSub 
     * @returns 
     */
    const onClickButton = function(event, isSubSub = false, stopPropagation = false) {
        if (event.type === "keyup" && !(event.key == `Enter` || event.key == `Space`)) return false;

        if (stopPropagation) event.stopPropagation();

        //Controllo che il bottone non sia già selezionato. Se lo è bypasso il click e di conseguenza la chiusura.
        /*if (isSubSub) {
            const buttonTarget = event.target.closest(`button`);
            if (buttonTarget.hasAttribute(`aria-expanded`) && buttonTarget.getAttribute(`aria-expanded`).toLowerCase() == `true`) {
                return;
            }
        }*/

        let target = event.target.classList.contains(`ico-expanded`) ? event.currentTarget : event.target;
        target = target.parentNode;

        const expandedClass = getOption(`expanded_class`);

        //Chiudi tutti i sub-sub-menu aprendo un nuovo sub-sub-menu.
        if (isSubSub && !target.classList.contains(expandedClass)) {
            const allOpenSubSubMenus = document.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.${expandedClass}`);
            allOpenSubSubMenus.forEach(openMenu => {
                if (openMenu !== target) {
                    openMenu.classList.remove(expandedClass);

                    const button = openMenu.querySelector(`button${_buttonToggleSubSubMenuSelector}[aria-expanded]`);

                    if (button) {
                        button.setAttribute(`aria-expanded`, `false`);
                        const labels = getOption(`button_attributes`, `aria-label`);
                        if (labels) {
                            button.setAttribute(`aria-label`, labels.expand);
                        }

                        setSubMenuHeight(button);
                    }
                }
            });
        }

        //Chiudi tutti i sub-menu aprendo un altro sub-menu.
        if (!isSubSub && !target.classList.contains(expandedClass)) {
            document.querySelectorAll(`.${elementClasses.a11yMenuHasChildres}.${expandedClass}`).forEach(openedMenu => {
                if (openedMenu !== target) {
                    openedMenu.classList.remove(expandedClass);

                    const button = openedMenu.querySelector(`button${_buttonToggleSubMenuSelector}[aria-expanded]`);
                    if (button) {
                        button.setAttribute(`aria-expanded`, `false`);
                        const labels = getOption(`button_attributes`, `aria-label`);
                        if (labels) {
                            button.setAttribute(`aria-label`, labels.expand);
                        }
                    }

                    //Chiudi anche i sub-sub-menu aperti all'interno
                    openedMenu.querySelectorAll(`.${elementClasses.a11yMenuHasSubChildres}.${expandedClass}`).forEach(ssMenu => {
                        ssMenu.classList.remove(expandedClass);
                        const subSubButton = ssMenu.querySelector(`button${_buttonToggleSubSubMenuSelector}[aria-expanded]`);
                        if (subSubButton) {
                            subSubButton.setAttribute(`aria-expanded`, `false`);
                            const labels = getOption(`button_attributes`, `aria-label`);
                            if (labels) {
                                subSubButton.setAttribute(`aria-label`, labels.expand);
                            }
                            setSubMenuHeight(subSubButton);
                        }
                    });
                }
            });
        }

        const toggleSelector = isSubSub ? _buttonToggleSubSubMenuSelector : _buttonToggleSubMenuSelector
        const targetExpanded = isExpandedSubSubMenu(event.target, toggleSelector);

        if (!isSubSub || !targetExpanded) target.classList.toggle(expandedClass);
        const pageChanged = changeButtonAttribute(target, isSubSub);

        if (isSubSub && pageChanged) {
            const toggleButton = target.querySelector(_buttonToggleSubSubMenuSelector);
            if (toggleButton) {
                setSubMenuHeight(toggleButton);
            }
        }

        event.preventDefault();
    }

    const isMode = function(mode) {
        return getOption("mode").includes(mode);
    }

    const getParents = function(event, selector = elementClasses.a11yMenuHasSubChildres) {
        let element = event.target || event;
        const parents = [];
        while (element && !getMenus().includes(element)) {
            if (element.matches && element.matches(`.${selector}`)) {
                parents.push(element);
            }

            element = element.parentNode;
        }

        return parents;
    }

    const onFocus = function(event) {
        const parents = getParents(event);

        parents.forEach(p => {
            p.classList.toggle(getOption(`expanded_class`), event.type === `focusin`);
        });

        if (isMode(`button`)) {
            changeButtonAttribute(event);
            parents.forEach(p => {
                changeButtonAttribute(p);
            });
        }
    }

    const onKeyESC = function(event) {
        if (event.key !== "Escape") return;

        const expandedClass = getOption(`expanded_class`);
        getMenus().forEach(menu => {
            menu.querySelectorAll(`.${expandedClass}`).forEach(el => {
                el.classList.remove(expandedClass);
                if (isMode(`button`)) {
                    changeButtonAttribute(el, false);
                    changeButtonAttribute(el, true);
                }
            });
        });
    }
    //#endregion
    
    let options = {};
    let menus = [];

    setOptions();
    polyFill();
    getMenus();

    if (menus.length && getOption(`expanded_class`)) {
        menus.forEach(menu => {
            const children = menu.querySelectorAll(getOption(`child_menu_selector`));
            if (children.length) {
                const toggleBtn = menu.querySelector(_buttonToggleSubMenuSelector);
                children.forEach(sub => {
                    const parent = sub.parentNode;
                    parent.classList.add(`${elementClasses.a11yMenuHasChildres}`);

                    if (toggleBtn) {
                        const trigger = sub.previousElementSibling;
                        changeButtonAttribute(parent);

                        trigger.addEventListener(`mousedown`, e => onClickButton(e, false, true));
                        trigger.addEventListener(`keyup`, e => onClickButton(e, false, true));

                        if (isMode(`touch`)) {
                            const link = parent.querySelector(`a[href]`);

                            if (link) {
                                link.addEventListener(`touchstart`, e => onTouchLink(e), true);
                            }
                        }
                    }
                });

                const subSubMenus = menu.querySelectorAll("." + elementClasses.subSubMenu);
                subSubMenus.forEach(subSubMenu => {
                    const parent = subSubMenu.parentNode;
                    parent.classList.add(elementClasses.a11yMenuHasSubChildres);

                    const trigger = parent.querySelector(_buttonToggleSubSubMenuSelector);
                    if (trigger) {
                        changeButtonAttribute(parent, true);

                        trigger.addEventListener(`mousedown`, e => onClickButton(e, true));
                        trigger.addEventListener(`keyup`, e => onClickButton(e, true));
                    }

                    if (isMode("touch")) {
                        const link = parent.querySelector(`a[href]`);
                        if (link) {
                            link.addEventListener(`touchstart`, e => onTouchLink(e, true), true);
                        }
                    }
                });

                if (isMode("tab")) {
                    menu.addEventListener(`focusin`, e => onFocus(e), true);
                    menu.addEventListener(`focusout`, e => onFocus(e), true);
                }

                if (isMode(`esc`)) {
                    document.addEventListener(`keyup`, e => onKeyESC(e));
                }
            }
        });
    }
}

function resetSubMenuHeights(mainNavSelector, menuNavSelector) {
    if (window.innerWidth < 1600) {
        document.querySelectorAll(`${mainNavSelector} ${menuNavSelector} .${elementClasses.subMenu}`).forEach(menu => {
            menu.style.height = 'auto';
        });
    }
}

function isExpandedSubSubMenu(button, subSubMenuClass) {
    if (!(button instanceof HTMLButtonElement)) {
        console.warn("The passed element on 'button' is not an HTMLButtonElement.");
        return false;
    }

    const expandedSubSubButtons = document.querySelectorAll(`button${subSubMenuClass}[aria-expanded="true"]`);
    return [...expandedSubSubButtons].includes(button);

}

function isHamburgerMenuVisible() {
    getComputedStyle(document.getElementById(`menu-toggle`)).display !== "none"
}